import type { ReactElement } from 'react';
import { api } from '../../../utils/api.ts';
import type { TransactionType } from '../hooks/use-draft-form.ts';
import { SearchSelect } from './search-select.tsx';

export type DocumentTypeInputProps = {
    customerId: string | undefined;
    disabled?: boolean;
    onChange?: (id: string) => void;
    placeholder?: string;
    storageId: string | undefined;
    transactionType: TransactionType;
    value?: string;
};

export function DocumentTypeInput({
    customerId,
    disabled,
    onChange,
    placeholder,
    storageId,
    transactionType,
    value,
}: DocumentTypeInputProps): ReactElement {
    const { data: documentTypeList, isLoading: isDocumentTypeListLoading } =
        api.platoUser.query.salesDraft.getSalesDraftOptions.getDocumentTypes.useQuery(
            {
                erpCustomerId: customerId ?? '',
                storageId,
                type: transactionType,
            },
            { enabled: !!customerId },
        );

    return (
        <SearchSelect
            disabled={disabled}
            items={documentTypeList}
            idSelector={(x) => x.id}
            isLoading={isDocumentTypeListLoading}
            onSelectedIdChange={onChange}
            placeholder={placeholder}
            renderItem={(x) => `${x.id} ${x.name}`}
            selectedId={value}
            textSelector={(x) => `${x.id} ${x.name}`}
        />
    );
}
